module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_Wood.2a78fe3a.jpg";